/**
 * AeroSpray contact form.
 *
 * Reproduces the source form's behaviour: picking a service reveals only the
 * follow-up fields that service needs, and the choice travels to the store
 * inbox through hidden `contact[...]` inputs on Shopify's native contact form.
 */
(() => {
  const init = (root) => {
    root.querySelectorAll('.aero-contact__form').forEach((form) => {
      if (form.dataset.aeroReady) return;
      form.dataset.aeroReady = 'true';

      const options = [...form.querySelectorAll('[data-aero-option]')];
      const propertyChips = [...form.querySelectorAll('[data-aero-property]')];
      const conditionals = [...form.querySelectorAll('[data-aero-conditional]')];
      const regarding = form.querySelector('[data-aero-regarding]');
      const propertyValue = form.querySelector('[data-aero-property-value]');

      const setPressed = (list, active) => {
        list.forEach((el) => el.setAttribute('aria-pressed', String(el === active)));
      };

      const clearFields = (section) => {
        section.querySelectorAll('input, textarea').forEach((field) => {
          field.value = '';
        });
        section.querySelectorAll('[aria-pressed="true"]').forEach((el) => {
          el.setAttribute('aria-pressed', 'false');
        });
      };

      const applyNeeds = (needs) => {
        conditionals.forEach((section) => {
          const key = section.dataset.aeroConditional;
          const show = needs.includes(key);
          if (show === !section.hidden) return;
          section.hidden = !show;
          // A hidden field must not submit a stale value from an earlier choice.
          if (!show) clearFields(section);
        });
      };

      options.forEach((option) => {
        option.addEventListener('click', () => {
          const selected = option.getAttribute('aria-pressed') === 'true';
          const active = selected ? null : option;
          setPressed(options, active);
          if (regarding) regarding.value = active ? active.dataset.value : '';
          applyNeeds(active ? (active.dataset.needs || '').split(/\s+/).filter(Boolean) : []);
          if (!active && propertyValue) propertyValue.value = '';
        });
      });

      propertyChips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const selected = chip.getAttribute('aria-pressed') === 'true';
          const active = selected ? null : chip;
          setPressed(propertyChips, active);
          if (propertyValue) propertyValue.value = active ? active.dataset.value : '';
        });
      });

      applyNeeds([]);
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
